import { NICmsContentComponent } from '@icms/core/content';

export namespace NPageComponentFaqComponent {
    export const ID = 'faq-comopnent';

    export interface IComponentData extends NICmsContentComponent.IData {
        faqsTitle?: string;
        textStyle?: string;
        textColor?: string;
        tag?: string;
        questionTag?: string;
        answerTag?: string;
        faqs?: IPageComponentFAQsData[];
    }

    export interface IPageComponentFAQsData {
        question: string;
        questionStyle?: string;
        questionColor?: string;
        answer: string;
        answerStyle?: string;
        answerColor?: string;
    }
}
